import React from 'react'
export default function Pagination() {
    return(
        <>Pagination page</>
    )
}